import React, { useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, NavLink, withRouter } from 'react-router-dom';
import useOnClickOutside from '../../common/useOnClickOutside';
import { UserRoles } from '../../domain/Models';
import lottery from '../../lottery';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
import style from './Navbar.module.scss';
var Navbar = function (_a) {
    var _b;
    var match = _a.match;
    var t = useTranslation()[0];
    var _c = useContext(UserContext), user = _c.user, logout = _c.logout;
    var _d = useState(false), showPrizesNav = _d[0], setShowPrizesNav = _d[1];
    var _e = useState(false), showUserNav = _e[0], setShowUserNav = _e[1];
    var prizesNavRef = useRef();
    var userNavRef = useRef();
    useOnClickOutside(prizesNavRef, function () {
        setShowPrizesNav(false);
    });
    useOnClickOutside(userNavRef, function () {
        setShowUserNav(false);
    });
    return React.createElement("div", { className: style.navbar },
        React.createElement("div", { className: style['navbar-inner'] },
            React.createElement(Link, { to: "/", className: style.logo },
                React.createElement("span", { className: style.lotus }, t('lotus')),
                React.createElement("span", { className: style.lottery }, lottery.title)),
            React.createElement("div", { className: style.right },
                React.createElement("ul", { className: style.nav },
                    user.role !== UserRoles.Finance && React.createElement("li", null,
                        React.createElement(NavLink, { to: "/dashboard", activeClassName: style.active }, t('dashboard'))),
                    user.role !== UserRoles.Finance && React.createElement("li", null,
                        React.createElement(NavLink, { to: "/draws", activeClassName: style.active }, t('draws'))),
                    user.role !== UserRoles.Finance && React.createElement("li", null,
                        React.createElement(NavLink, { to: "/tickets", activeClassName: style.active }, t('tickets'))),
                    React.createElement("li", { ref: prizesNavRef },
                        React.createElement("span", { onClick: function () { return setShowPrizesNav(function (show) { return !show; }); }, className: gs((_b = {}, _b[style.active] = match.path.startsWith('/prize'), _b)) },
                            t('prizes'),
                            ' ',
                            React.createElement("small", null,
                                React.createElement(FontAwesomeIcon, { icon: "angle-down" }))),
                        showPrizesNav && React.createElement("ul", null,
                            user.role !== UserRoles.Finance && React.createElement("li", null,
                                React.createElement(NavLink, { to: "/prize-schemes", onClick: function () { return setShowPrizesNav(false); }, activeClassName: style.active }, t('prize_schemes'))),
                            React.createElement("li", null,
                                React.createElement(NavLink, { to: "/prize-distributors", onClick: function () { return setShowPrizesNav(false); }, activeClassName: style.active }, t('prize_distribution')))))),
                user && React.createElement("div", { className: style['user'], ref: userNavRef },
                    React.createElement("span", { onClick: function () { return setShowUserNav(function (show) { return !show; }); }, className: gs(style['user-name']) },
                        React.createElement(FontAwesomeIcon, { icon: "user-circle" }),
                        ' ',
                        user.name,
                        ' ',
                        React.createElement("small", null,
                            React.createElement(FontAwesomeIcon, { icon: "angle-down" }))),
                    showUserNav && React.createElement("div", { className: style['user-nav'] },
                        React.createElement("ul", { className: gs('nav', 'flex-column') },
                            React.createElement("li", { className: gs('nav-item') },
                                React.createElement("a", { onClick: function () { return logout.post(); }, className: gs('nav-link', 'link', { 'disabled': logout.loading }), tabIndex: -1 }, t('log_out')))))))));
};
export default withRouter(Navbar);
